// Module
var code = "<repre ng-model=\"fbdata\" repre-add=\"!readOnly && component.insert !== false\" repre-validate=\"component.validate\" ng-disabled=\"readOnly || component.disabled\"></repre> ";
// Exports
export default code;